export const API_URL = "https://chiroquote.com/";
// export const API_URL = "http://192.168.8.111:8000/";
// export const API_URL = "http://127.0.0.1:8000/";


export const statusOptions: string[] = [
    "Applicant",
    "Bound",
    "Cancelled",
    "Client",
    "ERP",
    "Expired",
    "Non-renewed",
    "Proposed",
    "Prospect",
    "Quoted",
    "Suspect",
  ];

export const schoolOptions: string[] = [
    "Bellevue",
    "Bridgeport",
    "Campbellsville",
    "Canada CC",
    "Cleveland",
    "D'Youville" ,
    "Keiser",
    "Life-GA",
    "Life West",
    "Logan",
    "Natl HS-IL",
    "Natl HS-FL",
    "NE HS",
    "NE HS-LI",
    "NW HS",
    "Other-Domestic",
    "Other-International",
    "Palmer-IA",
    "Palmer-CA",
    "Palmer-FL",
    "Parker",
    "Pittsburgh",
    "Sherman",
    "SoCal HS",
    "Texas CC",
    "UCC",
    "Western"
]

export const claimStatusOptions: string[] = ["None","Claim - Open","Claim - Closed", "Incident - Open", "Incident - Closed","Suit - Open", "Suit - Closed"]

export const practiceStateOptions: string[] = ["AL", 
				"AK", 
				"AZ", 
				"AR",
				"CA"
				,"CO"
				,"CT"
				,"DC"
				,"DE"
				,"FL"
				,"GA"
				,"HI"
				,"ID"
				,"IL"
				,"IN"
				,"IA"
				,"KS"
				,"KY"
				,"LA"
				,"ME"
				,"MD"
				,"MA"
				,"MI"
				,"MN"
				,"MS"
				,"MO"
				,"MT"
				,"NE"
				,"NV"
				,"NH"
				,"NJ"
				,"NM"
				,"NY"
				,"NC"
				,"ND"
				,"OH"
				,"OK"
				,"OR"
				,"PA"
				,"PR"
				,"RI"
				,"SC"
				,"SD"
				,"TN"
				,"TX"
				,"UT"
				,"VT"
				,"VA"
				,"WA"
				,"WV"
				,"WI"
				,"WY"]

export const mailingStateOptions: string[] = [
    "AL", 
    "AK", 
    "AZ", 
    "AR",
    "CA"
    ,"CO"
    ,"CT"
    ,"DC"
    ,"DE"
    ,"FL"
    ,"GA"
    ,"HI"
    ,"ID"
    ,"IL"
    ,"IN"
    ,"IA"
    ,"KS"
    ,"KY"
    ,"LA"
    ,"ME"
    ,"MD"
    ,"MA"
    ,"MI"
    ,"MN"
    ,"MS"
    ,"MO"
    ,"MT"
    ,"NE"
    ,"NV"
    ,"NH"
    ,"NJ"
    ,"NM"
    ,"NY"
    ,"NC"
    ,"ND"
    ,"OH"
    ,"OK"
    ,"OR"
    ,"PA"
    ,"PR"
    ,"RI"
    ,"SC"
    ,"SD"
    ,"TN"
    ,"TX"
    ,"UT"
    ,"VT"
    ,"VA"
    ,"WA"
    ,"WV"
    ,"WI"
    ,"WY"
]

export const communicationOptions: string[] = ["Email", "Fax","Mail"]

export const sourceOptions: string[] = ["Ad","CE Class","Client Referral","Conference/Meeting","Direct Mail","Email","Facebook","Higginbotham","ICPA","Matt", "Other","Search Engine","The Joint-C","The Joint-F","Tony"]

export const priorCarrierOptions: string[] = [
    "ACE Ins. Co.",
    "Allied Professionals",
    "CBS",
    "Chirosecure",
    "CNA Insurance",
    "Evanston Insurance",
    "Liberty Surplus",
    "Lloyds",
    "Medical Protective",
    "National Union (AIG)",
    "NCC",
    "NCMIC",
    "OUM Insurance",
    "PACO Assurance",
    "Phi Omega Delta",
    "Philadelphia Ins.",
    "PRI",
    "Other",
    "None",
    "New DC"
]

export const haveBopOptions: string[] =["Yes","No","Xdate","NA"]

export const financeOptions: string[] =["Monthly","PIF","Quarterly","Quarterly - ACH"]

export const limitsOptions: string[] = ["$100,000/$300,000", "$200,000/$600,000", "$250,000/$750,000","$500,000/$1,500,000",
				"$1,000,000/$3,000,000"]

export const supplimitsOptions: string[] = ["$50,000","$75,000","$100,000"]

export const ratingadjustOptions: string[] = [
    "Acupuncture",
    "Additional Insured - Landlord",                                                                        
    "Additional Insured - Other", 
    "Animal Adjusting",
    "Consent to Settle",
    "Continuing Education",
    "Cyber Liability",
    "Disability/Leave of Absence",
    "Extended Reporting Year 1",                                                                           
    "Extended Reporting Year 2",                                                                           
    "Extended Reporting Year 3",                                                                           
    "Extended Reporting Year 4 or more",
    "Medical Professional - Acupuncurist",   
    "Medical Professional - Massage Therapist",                                                             
    "Medical Professional - Physical Therapist", 
    "Medical Professional - Registered Dietician",
    "Medical Professional - X-Ray Technician", 
    "Risk Management 5%",
    "Risk Management 10%",
    "Schedule Modification - Communication vehicle for patient questions and concerns",
    "Schedule Modification - Cooperation with insurer",
    "Schedule Modification - Cooperation with insurer 2",
    "Schedule Modification - Demographics of patient group",    
    "Schedule Modification - Effective risk management program",
    "Schedule Modification - Established policies and procedures for patient relations", 
    "Schedule Modification - High risk or experimental procedures or treatment",   
    "Schedule Modification - Loss experience",
    "Schedule Modification - Ongoing quality improvement program",
    "Schedule Modification - Other risk deviations specific to the account", 
    "Schedule Modification - Qualifications and Experience of Management",                                  
    "Schedule Modification - Rehearsed emergency plan/equipment in place",                                                      
    "Schedule Modification - Selection and supervision of staff",  
    "Schedule Modification - Thorough documentation of patient care and interaction",  
    "Schedule Modification - Use of recognized system of clinical guidelines",                              
    "Schedule Modification - Well-maintained patient record system",                                        
    "Separate Limit - Corp/Partnership",
    "Vicarious Liability"
]

export const transactionOptions: string[] = [
    "New Business",
    "Renewal",
    "Cancellation",
    "Flat Cancellation",
    "State Tax",
    "State Fee",
    "County Tax",
    "City Tax",
    "State Surcharge",
    "RPG Fee"
]
export interface InqueryRequest{
    first_name: string,
    last_name: string,
    license_number: string,
    date_first_licensed: Date,
    email: string,
    emailConfirm: string,
    telephone: string,
    office_phone: string,
    cell_phone: string,
    practice_address: string,
    practice_city: string,
    practice_state: string,
    practice_zip_code: string,
    
    policy_type: string,
    insurance_company: string,
    ll_requested: string,
    retroactive_claims_made_date: Date,
    current_policy_expiration_date: Date,

    practice_hours_per_week: number,
    chiropractors_number: number,
    employee_type: string,
    attended_risk_management: boolean,
    malpractice_claim: boolean,
    malpractice_claim_date: Date,
    pending_investigation: boolean,
    convicted_felony: boolean,
    contact_about_us: string,
    
    acupuncture: boolean,
    adjustments: boolean,
    applied_kinesiology: boolean,
    neuro_feedback_therapy: boolean,
    foot_bath: boolean,
    hair_analysis: boolean,
    homeopathy: boolean,
    braincore_therapy: boolean,
    interferential: boolean,
    interpretation_of_diagnostic: boolean,
    microcurrent: boolean,
    spinal_decompression: boolean,
    treatment_of_diagnosis: boolean,
    urinalysis: boolean,
  }

  export interface InqueryResponse{
    success: boolean,
    msg: string
  }

  export interface PracticeState{
    name: string,
    abbreviation: string
  }

  export interface VerifyInfo{
    lastname: string,
    practicezip: string,
    licensenumber: string,
    policynumber: string,
    dateofbirth: Date,
    pin: string
  }

  export interface VerifyResult{
    bSuccess: Boolean,
    msg: string
    waitSeconds?: number
  }

export interface LoginResponse {
  success: boolean;
  access_token: string;
  token_type: string;
  login_session: {
      user: {[key: string]: string},
      carriers: [],
      users: { [key: string]: string },
      usersReverse: { [key: string]: string },
      slcodes: { [key: string]: string }
      balance: "",
      nonresident: boolean,
      welcomeNotice: number,
      warningNotice: number,
  }
}
export interface ErrorResponse {
  success: boolean;
  errorMsg : string;
}

export interface LoginRequest{
  username: string,
  password: string,
}

export type LoginResult = LoginResponse | ErrorResponse;

export interface DemographicsData{
    fileid: number,
    lastname: string,
    firstname: string,
    company: string,
    dba: string,
    status: string,
    vipstatus: string,
    licenseNumber: string,
    ams: string,
    startdate: Date,
    graduationdate: Date,
    dob: Date,
    practiceaddress1: string,
    practiceaddress2: string,
    practicecity: string,
    practicestate: string,
    practicezip: string,
    mailingaddress1: string,
    mailingaddress2: string,
    mailingcity: string,
    mailingstate: string,
    mailingzip: string,
    telephone: string,
    telephone2: string,
    fax: string,
    email: string,
    email2: string,
    web: string,
    comm: string,
    csr: string,
    source: string,
    territory: string,
    lastclaim: Date,
    producer: string,
    priorcarrier: string,
    groupID: number,
    exdate: Date,
    patientcount: number,
    havecert: string,
    nutritionpercent: string,
    FEIN: string,
    icpa: string,
    havebop: string,
    imptnotes: string,
    finance: string,
    claim: string,
    xreference: string,
    Nocoverage: string,
    AdminEmail: string,
    AdminName: string,
    AdminAddress: string,
    Company2: string,
    School: string,
    username: string,
    password: string
}

  export interface DashboardFieldValue {
    current?: string,
    changed?: string,
  }

  export interface DashboardData {
    company?: DashboardFieldValue,
    dba?: DashboardFieldValue,
    School?: DashboardFieldValue,
    practiceaddress1?: DashboardFieldValue,
    practiceaddress2?: DashboardFieldValue,
    practicestate?: DashboardFieldValue,
    practicecity?: DashboardFieldValue,
    practicezip?: DashboardFieldValue,
    mailingaddress1?: DashboardFieldValue,
    mailingaddress2?: DashboardFieldValue,
    mailingcity?: DashboardFieldValue,
    mailingzip?: DashboardFieldValue,
    telephone?: DashboardFieldValue,
    telephone2?: DashboardFieldValue,
    fax?: DashboardFieldValue,
    email?: DashboardFieldValue,
    email2?: DashboardFieldValue,
    web?: DashboardFieldValue,
  }

  export interface PolicyRenewalFormData {
    hours_per_week?: number,

    acupuncture?: boolean,
    automated_spinal_decompression?: boolean,
    colon_irrigation?: boolean,
    craniosacral_therapy?: boolean,
    cupping?: boolean,
    dot_exams?: boolean,
    drugs_prescribed_or_injected?: boolean,
    dry_needling?: boolean,
    foot_bath?: boolean,
    functional_medicine?: boolean,
    gynecology_exams?: boolean,
    hair_analysis?: boolean,
    homeopathy?: boolean,
    hyperbaric_oxygen_therapy?: boolean,
    iodbs?: boolean,
    invasive_emg?: boolean,
    iridology?: boolean,
    minor_surgery?: boolean,
    mua?: boolean,
    obstetrics?: boolean,
    red_light_therapy?: boolean,
    sauna?: boolean,
    treatment_diagnosis?: boolean,
    urinalysis?: boolean,
    vitamin_injections?: boolean,

    otherchiro?: boolean,
    massage?: boolean,
    acupuncturist?: boolean,
    physical_therapist?: boolean,
    doula?: boolean,
    midwife?: boolean,
    medical_doctor?: boolean,
    other?: boolean,

    initial1?: string,
    initial2?: string,
    initial3?: string,
    initial4?: string,
    signed?: string,
    signed_date?: string,
    dashboard?: DashboardData,
  }

  export interface PolicyRenewalSaveRequest extends PolicyRenewalFormData {
    fileid: number,
  }

  export interface PolicyRenewalResult {
    bSuccess: boolean,
    msg: string,
    formData?: PolicyRenewalFormData,
  }

export interface GetDemographicResponse{
    success: boolean,
    demographic: DemographicsData
}
export type GetDemographicResult = GetDemographicResponse | ErrorResponse;
